/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
window.addEventListener("load", async () => {
  const response = await fetch(
    `${gvvAjax.ajax_url}?action=get_latest_result_iso`
  );
  if (response.status !== 200) {
    console.error("Error fetching latest result:", response.statusText);
    return;
  }
  const { data: result } = await response.json();
  document.querySelectorAll(".hometeam-logo").forEach((el) => {
    el.style.backgroundImage = `url(${result.hometeam_logo})`;
  });
  document.querySelectorAll(".awayteam-logo").forEach((el) => {
    el.style.backgroundImage = `url(${result.awayteam_logo})`;
  });
  document
    .querySelectorAll(".wp-block-gvv-last-score__left__team")
    .forEach((el) => {
      el.innerText = result.hometeam_name;
    });
  document
    .querySelectorAll(".wp-block-gvv-last-score__right__team")
    .forEach((el) => {
      el.innerText = result.awayteam_name;
    });
  document
    .querySelectorAll(".wp-block-gvv-last-score__center")
    .forEach((el) => {
      el.innerText = result.score.replaceAll(" ", "");
    });
});
/* eslint-enable no-console */
